/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-self-assign */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";

import { Link, useLocation, useHistory } from "react-router-dom";

import { useAuthentication } from "../../../hooks/useAuth";

import Content from "../../../components/Content";
import CardHeader from "../../../components/CardHeader";
import CustomModal from "../../../components/Modal";
import ButtonCard from "../../../components/ButtonCard";

import api from "../../../services/api";

import { decrypt } from "../../../util/rotinas";
import ItemMenu from "../../../components/ItemMenu/ItemMenu";
import { toast } from "react-toastify";

import userImg from '../../../assets/userImg.png'
import icon from '../../../assets/icon.png'
import iconWhite from '../../../assets/iconWhite.png'

export default function Menu() {
  const { handleLogout } = useAuthentication();

  const history = useHistory();
  const modalRef = useRef(null);

  const location = useLocation();
  const route = location.pathname;
  let routeAtual = route.replace("/", "");

  if (routeAtual === "") {
    routeAtual = "/";
  }

  let buscaRoute = routeAtual.split("/");
  let indexBusca = buscaRoute[0];

  if (indexBusca === "") {
    indexBusca = "/";
  }

  const [user, setUser] = useState(null);
  const [senha, setSenha] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confSenha, setConfSenha] = useState("");

  const [showModalAltSenha, setShowModalAltSenha] = useState(false);

  const [permissionsCadastro, setPermissionsCadastro] = useState([]);
  const [permissionsConfig, setPermissionsConfig] = useState([]);
  const [listScreens, setListScreens] = useState([]);

  const [permissionProfile, setPermissionProfile] = useState([])

  const [statusCadastrosMenu, setStatusCadastrosMenu] = useState(false);

  if (showModalAltSenha === true) {
    indexBusca = "/";
  }

  const handleSubmitChangePassword = async function (e) {
    e.preventDefault();
    try {
      const {
        data: { data },
      } = await api.put(`/user/change-pass/${user.id}`, {
        password: senha,
        new_pass: novaSenha,
        conf_new_pass: confSenha,
      });
      toast.success(`Senha alterada com sucesso.`, {
        position: "bottom-center",
        autoClose: true,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: 0,
      });
      setTimeout(() => {
        handleLogout();
      }, 3000);
      setSenha("");
      setNovaSenha("");
      setConfSenha("");
      setShowModalAltSenha(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const u = decrypt(localStorage.getItem("@ipm:user"), true);
    setUser(u);

    const acessos = u?.profile?.access;
  
    let aList;
    let aListArray;

    // aList = acessos?.filter((a) => a.menuPai === "cadastros");
    // if (aList.length !== 0) setStatusCadastrosMenu(true);
    setStatusCadastrosMenu(true);

    let listHasAccess = acessos.filter(
      (item) => item.has_access
    );

    const nomeTelaArray = []
    const temp = listHasAccess.map((item) => item.screen_name);
    temp.forEach((item) => {
      if (!nomeTelaArray.includes(item)) {
        nomeTelaArray.push(item)
      }
    })
    setListScreens(nomeTelaArray)
  }, []);

  const handleClose = () => {
    setSenha("");
    setNovaSenha("");
    setConfSenha("");
    setShowModalAltSenha(false);
  };

  return (
    <>
      <div>
        <aside className="main-sidebar sidebar-dark-primary elevation-1">
          <Link to="/" style={{ cursor: "pointer" }} className="brand-link">
            <div style={{ display: 'flex', alignItems: 'center' }}>

              <img
                src={iconWhite}
                alt="Infarma PIX"
                className="brand-image img-circle elevation-4"
                style={{ opacity: ".8", width: "29px" }}
              />
              {/* <b> */}
              <span
                className="brand-text font-weight-light"
                style={{ fontSize: "20px" }}
              >
                INFARMA PIX
              </span>
            </div>
            {/* </b> */}
          </Link>
          <div className="sidebar">
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="image">
                <img
                  src={userImg}
                  className="img-circle elevation-2"
                  alt="User Image"
                />
              </div>
              <div className="info">
                <a href="#" className="d-block">
                  {user ? user.name : "Usuário"}
                </a>
                <a href="#">
                  <small>{user ? user.profile.name : "Perfil"}</small>
                </a>
              </div>
            </div>

            <nav id="navMenu" className="mt-2">
              <ul
                className="nav nav-pills nav-sidebar nav-child-indent flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <li className="nav-item">
                  <Link
                    to="/"
                    id="dashMenu"
                    style={{ cursor: "pointer", padding: "0" }}
                    className="nav-link"
                  >
                    <ItemMenu
                      selectedColor={routeAtual === "/"}
                      colorContent={routeAtual === "/" ? "#007BFF" : "none"}
                      classIcon="nav-icon fa fa-tachometer"
                      nameItem="Dashboard"
                    />
                  </Link>
                </li>

                {statusCadastrosMenu ? (
                  <li className="nav-item" style={{ padding: "0" }}>
                    <a
                      href="#"
                      style={{ cursor: "pointer", padding: "0" }}
                      className="nav-link"
                    >
                      <ItemMenu
                        nameItem="Cadastros"
                        colorContent={
                          indexBusca === "customer"
                            ? "#007BFF"
                            : "none"
                        }
                        classIcon="nav-icon fa fa-edit"
                        classIconEnd="fa fa-angle-left right"
                      />
                    </a>
                    <ul className="nav nav-treeview">
                      {listScreens.includes("customer") ? (
                        <>
                          <li className="nav-item">
                            <Link
                              to="/customer"
                              id="cliMenu"
                              style={{ cursor: "pointer", padding: "0" }}
                              className="nav-link"
                            >
                              <ItemMenu
                                selectedColor={indexBusca === "custumer"}
                                colorContent={
                                  indexBusca === "customer" ? "#EBECEC" : "none"
                                }
                                classIcon="fa fa-university nav-icon"
                                nameItem="Clientes"
                              />
                            </Link>
                          </li>
                        </>
                      ) : null}
                    </ul>
                  </li>
                ) : null}

                <li className="nav-item has-treeview" style={{ padding: "0" }}>
                  <Link
                    to="#"
                    id="reportMenu"
                    style={{ cursor: "pointer", padding: "0" }}
                    className="nav-link"
                  >
                    <ItemMenu
                      nameItem="Relatórios"
                      colorContent={
                        indexBusca === "reports"
                          ? "#007BFF"
                          : "none"
                      }
                      classIcon="nav-icon fa fa-book "
                      classIconEnd="fa fa-angle-left right"
                    />
                  </Link>
                  <ul className="nav nav-treeview">
                    {listScreens.includes("reports") ? (
                      <>
                        <li className="nav-item">
                          <Link
                            to="/reports"
                            id="relMenu"
                            style={{ cursor: "pointer", padding: "0" }}
                            className="nav-link"
                          >
                            <ItemMenu
                              selectedColor={indexBusca === "reports"}
                              colorContent={
                                indexBusca === "reports" ? "#EBECEC" : "none"
                              }
                              classIcon="fa fa-list nav-icon"
                              nameItem="Movimentações"
                           
                            />
                          </Link>
                        </li>
                      </>
                    ) : null}
                  </ul>
                </li>

                <li className="nav-item has-treeview" style={{ padding: "0" }}>
                  <Link
                    to="#"
                    id="conMenu"
                    style={{ cursor: "pointer", padding: "0" }}
                    className="nav-link"
                  >
                    <ItemMenu
                      nameItem="Configurações"
                      colorContent={
                        indexBusca === "profile"
                          ? "#007BFF"
                          : "none"
                          //  | (indexBusca === "user")
                          //   ? "#007BFF"
                          //   : "none" | (indexBusca === "instituition")
                          //     ? "#007BFF"
                          //     : "none"
                      }
                      classIcon="nav-icon fa fa-cog"
                      classIconEnd="fa fa-angle-left right"
                    />
                  </Link>
                  <ul className="nav nav-treeview">
                    {listScreens.includes("profile") ? (
                      <>
                        <li className="nav-item">
                          <Link
                            to="/profile"
                            id="perMenu"
                            style={{ cursor: "pointer", padding: "0" }}
                            className="nav-link"
                          >
                            <ItemMenu
                              selectedColor={indexBusca === "profile"}
                              colorContent={
                                indexBusca === "profile" ? "#EBECEC" : "none"
                              }
                              classIcon="fa fa-unlock-alt nav-icon"
                              nameItem="Perfis de Acesso"
                            />
                          </Link>
                        </li>
                      </>
                    ) : null}

                    {listScreens.includes("user") ? (
                      <>
                        <li className="nav-item">
                          <Link
                            to="/user"
                            id="usuMenu"
                            style={{ cursor: "pointer", padding: "0" }}
                            onClick={() => history.push("/user")}
                            className="nav-link"
                          >
                            <ItemMenu
                              selectedColor={indexBusca === "user"}
                              colorContent={
                                indexBusca === "user" ? "#EBECEC" : "none"
                              }
                              classIcon="fa fa-users nav-icon"
                              nameItem="Usuários"
                            />
                          </Link>
                        </li>
                      </>
                    ) : null}


                    {listScreens.includes("instituition") ? (
                      <>
                        <li className="nav-item">
                          <Link
                            to="/instituition"
                            id="instituitionMenu"
                            style={{ cursor: "pointer", padding: "0" }}
                            className="nav-link"
                          >
                            <ItemMenu
                              selectedColor={indexBusca === "instituition"}
                              colorContent={
                                indexBusca === "instituition" ? "#EBECEC" : "none"
                              }
                              classIcon="fa fa-building nav-icon"
                              nameItem="Instituições"
                            />
                          </Link>
                        </li>
                      </>
                    ) : null}

                    <li className="nav-item">
                      <a
                        id="altSenhaMenu"
                        style={{ cursor: "pointer", padding: "0" }}
                        onClick={() => setShowModalAltSenha(true)}
                        className="nav-link"
                      >
                        <ItemMenu
                          classIcon="fa fa-user-secret nav-icon"
                          nameItem="Alt. Senha"
                          colorContent={
                            showModalAltSenha ? "#EBECEC" : "none"
                          }
                        />
                      </a>
                    </li>
                  </ul>
                </li>


                <div className="user-panel mt-3 pb-3 mb-3 d-flex"></div>

                <li className="nav-item">
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={handleLogout}
                    className="nav-link"
                  >
                    <i className="fa fa-sign-out nav-icon" />
                    <p>Sair</p>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </aside>
      </div>

      <CustomModal
        id="modalTeste"
        open={showModalAltSenha}
        close={handleClose}
        modalRef={modalRef}
      >
        <form >
          <Content>
            <CardHeader
              title={"Alt. Senha"}
              icon={"fa-user-secret"}
              searchVisible={false}
            />
            <div className="box">
              <form>
                <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="senha_atual">Senha Atual *</label>
                      <input
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        type="password"
                        id="inputSenhaAtual"
                        className="form-control"
                        name="senha_atual"
                        placeholder="Senha Atual"
                      />
                    </div>
                  </div>
                </div>

                <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="nova_senha">Nova Senha *</label>
                      <input
                        value={novaSenha}
                        onChange={(e) => setNovaSenha(e.target.value)}
                        type="password"
                        id="inputNovaSenha"
                        className="form-control"
                        name="nova_senha"
                        placeholder="Nova Senha"
                      />
                    </div>
                  </div>
                </div>

                <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="conf_senha">Conf. Nova Senha *</label>
                      <input
                        value={confSenha}
                        onChange={(e) => setConfSenha(e.target.value)}
                        type="password"
                        id="inputConfSenha"
                        className="form-control"
                        name="conf_senha"
                        placeholder="Conf. Nova Senha"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Content>
        </form>

        <div className="col-lg-12" style={{ padding: "0" }}>
          <div className="row">
            <div className="col-lg-6 col-6">
              <ButtonCard
                className="small-box bg-info"
                onClick={handleSubmitChangePassword}
                title="Salvar"
              />
            </div>
            <div className="col-lg-6 col-6">
              <ButtonCard
                className="small-box bg-danger"
                onClick={handleClose}
                title="Cancelar"
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
